import { useState, useCallback } from 'react';

import type {
	TSensitiveDataWarningState,
	TUseSensitiveDataWarningReturn,
} from '../../conversation-panel-section.types';

export function useSensitiveDataWarning(): TUseSensitiveDataWarningReturn {
	const [sensitiveDataWarning, setSensitiveDataWarning] = useState<TSensitiveDataWarningState>({
		show: false,
		accepted: undefined,
	});

	const toggleSensitiveDataWarning = useCallback(
		(show: boolean, accepted: boolean | undefined) => {
			setSensitiveDataWarning({ show, accepted });
		},
		[],
	);

	return { sensitiveDataWarning, toggleSensitiveDataWarning };
}
